import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-share-dialog',
  templateUrl: './share-dialog.component.html',
  styleUrls: ['./share-dialog.component.scss'],
  standalone: false,
})
export class ShareDialogComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  currentLink: string;
  qrCodeUrl: string = '';

  shareAppsAsPost = [
    {
      name: 'Facebook',
      icon: 'facebook',
      logo: '../../../../assets/images/facebook-logo.png',
      color: '#3F51B540',
      url: 'https://facebook.com/sharer/sharer.php?u=',
    },
    {
      name: 'Instagram',
      icon: 'photo_camera',
      logo: '../../../../assets/images/nstagram.png',
      color: '#DA1A5F40',
      url: 'https://www.instagram.com/?url=',
    },
    {
      name: 'Twitter',
      icon: 'twitter',
      logo: '../../../../assets/images/twitter.png',
      color: '#03A9F440',
      url: 'https://twitter.com/intent/tweet?url=',
    },
  ];

  shareAppsAsMessage = [
    {
      name: 'Whatsapp',
      icon: 'chat',
      logo: '../../../../assets/images/whatsapp.png',
      color: '#40C35140',
      url: 'https://api.whatsapp.com/send?text=',
    },
    {
      name: 'Messenger',
      icon: 'message',
      logo: '../../../../assets/images/messenger.png',
      color: '#448AFF40',
      url: 'https://www.messenger.com/t/?link=',
    },
    {
      name: 'Telegram',
      icon: 'send',
      logo: '../../../../assets/images/telegram.png',
      color: '#29B6F640',
      url: 'https://t.me/share/url?url=',
    },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ShareDialogComponent>
  ) {
    this.currentLink = `${data.baseUrl}${data.slug}`;
  }

  ngOnInit(): void {
    this.generateQRCode(this.currentLink);
  }

  generateQRCode(link: string) {
    this.qrCodeUrl = `https://quickchart.io/qr?text=${encodeURIComponent(
      link
    )}&size=200&dark=000000&light=FFFFFF`;
  }

  shareWebsite(): void {
    if (navigator.share) {
      navigator
        .share({
          title: 'Share Website',
          text: 'Check out this website:',
          url: this.currentLink,
        })
        .then(() => console.log('Successfully shared'))
        .catch((error) => console.error('Error sharing:', error));
    } else {
      alert('Sharing is not supported on this device.');
    }
  }

  share(app: any) {
    const shareUrl = `${app.url}${encodeURIComponent(this.currentLink)}`;
    window.open(shareUrl, '_blank');
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentLink).then(() => {
      this._snackBar.open('Link copied to clipboard!', 'Close', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
      });
    });
  }

  downloadQrCode() {
    if (this.qrCodeUrl.startsWith('data:image')) {
      const link = document.createElement('a');
      link.href = this.qrCodeUrl;
      link.download = 'qr-code.png';
      link.click();
      this._snackBar.open('QR Code downloaded!', 'Close', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
      });
    } else {
      fetch(this.qrCodeUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'qr-code.png';
          link.click();
          this._snackBar.open('QR Code downloaded!', 'Close', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center',
          });
        })
        .catch((err) => console.error('Error downloading QR code:', err));
    }
  }

  closeModal() {
    this.close.emit();
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
